export default "__VITE_ASSET__90910594__"